import { render } from "./AppView.vue?vue&type=template&id=a1223b2e&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"

import "./AppView.vue?vue&type=style&index=0&id=a1223b2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1223b2e"]])

export default __exports__